module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-GOFUNDME.2584137f.png";